export default "__VITE_ASSET__DIfrO4$P__"